/* eslint-disable import/prefer-default-export */
import breadcrumbSchema from '../schemas/breadcrumb';

export const generateBreadcrumbs = ({ predictorURL }) => {
  const breads = [
    {
      name: 'Home',
      url: 'https://unacademy.com'
    },
    {
      name: 'Rank Predictor',
      url: predictorURL
    }
  ];

  return breadcrumbSchema(breads);
};
